import { has } from 'lodash';

export class ReturnOnlyField {
    private isRoot = false;
    private name = '';
    private children: ReturnOnlyField[] = [];

    public setRoot(): ReturnOnlyField {
        this.isRoot = true;
        return this;
    }

    public from(tree: any): ReturnOnlyField {
        if (tree instanceof ReturnOnlyField) {
            return tree;
        }

        Object.entries(tree).forEach(([key, value]) => {
            let field = new ReturnOnlyField();

            field.setName(key);
            if (typeof value === 'object') {
                field = field.from(value);
            }

            this.add(field);
        });

        return this;
    }

    public add(field: ReturnOnlyField): ReturnOnlyField {
        this.children = [...this.children, field];
        return this;
    }

    public toString(): string {
        if (this.children.length > 0) {
            let fields = this.name;
            if (this.isRoot) {
                fields = '';
            } else {
                fields += '{';
            }

            this.children.forEach((child) => {
                fields += child.toString() + ',';
            });

            fields = fields.trim().replace(/,$/, '');
            if (!this.isRoot) {
                fields += '}';
            }

            return fields;
        }

        return this.name;
    }

    /**
     * @return string
     */
    public getName(): string {
        return this.name;
    }

    public setName(name: string): ReturnOnlyField {
        this.name = name;
        return this;
    }

    public count(): number {
        if (this.children.length > 0) {
            return this.children.length;
        }

        if (!this.name) {
            return 1;
        }

        return 0;
    }

    public has(value) {
        return has(this.toJSON(), value);
    }

    public toJSON(): Record<string, any> {
        const record = {};
        this.children.forEach((child) => {
            record[child.getName()] = child.toJSON();
            if (typeof record[child.getName()] === 'object' && Object.values(record[child.getName()]).length === 0) {
                record[child.getName()] = true;
            }
        });

        return record;
    }

    public isEmpty() {
        return this.children.length === 0;
    }

    /**
     *
     * @param name
     */
    public get(name): ReturnOnlyField | null {
        return this.children.find(({ getName }) => getName() === name)[0] ?? null;
    }
}
